function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M235.1,199.4l-45-13.5c-5.2-1.6-8.8-6.8-8.8-12.7c0-7.3,5.3-13.2,11.8-13.2h28.1c4.6,0,9,1.3,12.8,3.7 c3.2,2,7.4,1.9,10.1-0.7l11.8-11.2c3.5-3.4,3.3-9.2-0.6-12.1c-9.1-6.8-20.1-10.8-31.4-11.4V112c0-4.4-3.6-8-8-8h-16 c-4.4,0-8,3.6-8,8v16.1c-23.6,0.6-42.7,20.6-42.7,45.1c0,20,13,37.8,31.6,43.4l45,13.5c5.2,1.6,8.8,6.8,8.8,12.7 c0,7.3-5.3,13.2-11.8,13.2h-28.1c-4.6,0-9-1.3-12.8-3.7c-3.2-2-7.4-1.9-10.1,0.7l-11.8,11.2c-3.5,3.4-3.3,9.2,0.6,12.1 c9.1,6.8,20.1,10.8,31.4,11.4V304c0,4.4,3.6,8,8,8h16c4.4,0,8-3.6,8-8v-16.1c23.6-0.6,42.7-20.5,42.7-45.1 C266.7,222.8,253.7,205,235.1,199.4L235.1,199.4z M508.5,481.6l-129-129c-2.3-2.3-5.3-3.5-8.5-3.5h-10.3C395,312,416,262.5,416,208 C416,93.1,322.9,0,208,0S0,93.1,0,208s93.1,208,208,208c54.5,0,104-21,141.1-55.2V371c0,3.2,1.3,6.2,3.5,8.5l129,129 c4.7,4.7,12.3,4.7,17,0l9.9-9.9C513.2,493.9,513.2,486.3,508.5,481.6L508.5,481.6z M208,384c-97.3,0-176-78.7-176-176 S110.7,32,208,32s176,78.7,176,176C384,305.3,305.3,384,208,384L208,384z"
});

var SvgIconSymbolSelector = function SvgIconSymbolSelector(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconSymbolSelector, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_symbol_selector.af9919c0.svg";
export { ForwardRef as ReactComponent };